





















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Journey, JourneyScopeEnum} from "./DisruptionModels";

@Component
export default class AbandonedPickDirection extends Vue {

    @Prop() journey: Journey;
    scope: JourneyScopeEnum = JourneyScopeEnum.Out;
    
    mounted() {
        if (!this.journey.tickets.some(t => t.journeyScope !== 'Out')) {
            this.$emit('save', JourneyScopeEnum.Out);
        }
    }

    doneFunc() {
        this.$emit('save', this.scope);
    }
}
